// let { REACT_APP_API_URL } = process.env;
import { localStore } from 'helpers';
import { connect } from 'react-redux';
import {
  apiUrl,
  apiUrlPublic,
  reportUrl,
  externalApi,
  customCDR
} from 'helpers/dotenv';
import axios from 'axios';
import store from 'store';
import consts from 'consts';

const { LOGIN_TOKEN_KEY, LOGIN_REFRESH_TOKEN_KEY } = consts;

let REACT_APP_API_URL;
let tAPI = localStore.getItem('REACT_APP_API_URL');
if (
  tAPI &&
  typeof tAPI !== 'undefined' &&
  tAPI !== 'undefined' &&
  tAPI !== ''
) {
  REACT_APP_API_URL = tAPI;
}

let { CUSTOMER_ID } = process.env;
let tCustomerId = localStore.getItem('USER_ID');
if (
  tCustomerId &&
  typeof tCustomerId !== 'undefined' &&
  tCustomerId !== 'undefined' &&
  tCustomerId !== ''
) {
  CUSTOMER_ID = tCustomerId;
}

var instance = null;
export class APIManager {
  constructor(tData) {
    if (instance) {
      return instance;
    }
    this.token = localStore.getItem('token');
    this.tenantId = ``;
    this.tURL = '';
    this.tDownloadUrl = '';
    // this.tURL = `${this.selectedOrganization.region.protocol}://${this.selectedOrganization.region.endpoint}/v1/`;
    // this.tDownloadUrl = `${this.selectedOrganization.region.protocol}://${this.selectedOrganization.region.endpoint}`;
    this.tURLPublic = apiUrlPublic;
    instance = this;
  }
  updateUrl(url, tenantId) {
    this.tURL = `${url}/v1/`;
    this.tDownloadUrl = `${url}`;
    this.tenantId = tenantId;
  }
  downloadUrl(fileName) {
    return `${this.tDownloadUrl}/${fileName}`;
  }
  removeByAttr(arr, attr, value) {
    var i = arr.length;
    while (i--) {
      if (
        arr[i] &&
        arr[i].hasOwnProperty(attr) &&
        arguments.length > 2 &&
        arr[i][attr] === value
      ) {
        arr.splice(i, 1);
      }
    }
    return arr;
  }

  async sendPostAPI(route, data, sCb, fCb, type, extraHeaders, method) {
    let url = this.tURL;
    var that = this;

    if (type && type === 'summaryReport') {
      url = reportUrl;
    } else if (type && type === 'customCDR') {
      url = customCDR;
    }
    const state = store.getState();
    const localstorageslice = state.localstorageslice;

    const RedixToken = localstorageslice ? localstorageslice.token : null;
    let header = {
      Authorization: `Bearer ${localStore.getItem('token')}`,
      'X-TENANT-ID': localStore.getItem('selected-tenant'),
      'Content-Type': 'application/json'
    };
    if (extraHeaders) {
      header = { ...header, ...extraHeaders };
    }

    if (type === 'public') {
      // delete header.Authorization;
      delete header['X-TENANT-ID'];
    }

    const token = localStore.getItem('erxesLoginToken')
      ? localStore.getItem('erxesLoginToken')
      : RedixToken;
    let cData = undefined;
    try {
      cData = JSON.stringify(data);
    } catch (e) {
      console.log(e);
    }
    let apiPath = url;
    if (type) {
      if (type == 'public' || type == 'public_auth') {
        apiPath = this.tURLPublic;
      } else if (type == 'direct') {
        apiPath = '';
      }
    }
    await fetch(`${apiPath}${route}`, {
      // fetch(`${this.tURL}${route}`, {
      method: method || 'POST',
      headers: header,
      body: cData
    })
      .then(async response => {
        console.log(`response:`, response);
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          // remove tokens

          window.location.href = '/';
        } else {
          let tBody = await response.json();
          fCb(response.status, tBody);
        }
      })
      .then(function(apiResponsData) {
        if (apiResponsData) {
          sCb(apiResponsData, data);
        }
      })
      .catch(e => {
        console.log(e);
        fCb(e);
      });
  }

  sendGetAPI(route, sCb, fCb, type = 'private') {
    var that = this;
    console.log(`this.tURLPublic `, this.tURLPublic, type);
    try {
      fetch(
        `${type && type == 'public' ? this.tURLPublic : this.tURL}${route}`,
        {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${localStore.getItem('token')}`,
            'X-TENANT-ID': localStore.getItem('selected-tenant'),
            'Content-Type': 'application/json'
          }
          // body: JSON.stringify(data)
        }
      )
        .then(async response => {
          console.log(`response.status === ${response.status}`);
          if (response.status === 200) {
            return response.json();
          } else if (response.status === 401) {
            this.clearStorage();
            window.location.href = '/';
          } else {
            let tBody = await response.json();
            fCb(response.status, tBody);
          }
        })
        .then(function(data) {
          sCb(data);
        })
        .catch(e => {
          console.log(e);
          fCb(e);
        });
    } catch (e) {
      console.log(e);
      fCb(e);
    }
  }
  getHeader(type, extraHeaders) {
    let header = {
      Authorization: `Bearer ${localStore.getItem('token')}`,
      'X-TENANT-ID': localStore.getItem('selected-tenant'),
      'Content-Type': type || 'application/json'
    };
    if (extraHeaders) {
      header = { ...header, ...extraHeaders };
    }
    return header;
  }
  sendPostForm(route, formData, sCb, fCb, extraHeaders, progressFn) {
    let headers = this.getHeader('multipart/form-data', extraHeaders);
    axios
      .post(`${this.tURL}${route}`, formData, {
        headers: headers,
        onUploadProgress: progressFn
      })
      .then(function(response) {
        console.log(`response:`, response);
        if (response.status === 200) {
          return response.data;
        } else if (response.status === 401) {
          this.clearStorage();
          window.location.href = '/';
        } else {
          let tBody = response.data;
          console.log('apiResponse', response.data);
          fCb(response.status, tBody);
        }
      })
      .then(function(data) {
        if (data) {
          sCb(data);
        }
      })
      .catch(error => {
        if (error.response) {
          // Request made and server responded
          fCb(error.response.status, error.response.data);
        } else {
          // Something happened in setting up the request that triggered an Error
          fCb(0, { message: 'no response' });
        }
      });
  }
  clearStorage() {
    localStorage.removeItem(LOGIN_TOKEN_KEY);
    localStorage.removeItem(LOGIN_REFRESH_TOKEN_KEY);
    localStorage.removeItem('REACT_APP_API_SUBSCRIPTION_URL');
    localStorage.removeItem('REACT_APP_API_URL');
    localStorage.removeItem('REACT_FS_SERVER_HOST');
    localStorage.removeItem('USER_ID');
    // localStore.removeItem('selected-tenant');
    localStore.removeItem('token');
    localStore.removeItem('user');
  }
}
const mapStateToProps = state => ({
  user: state.user,
  menu: state.user.menu,
  isLogin: state.user.isLogin,
  currentUser: state.user.user,
  localstorageslice: state.localstorageslice
});

const mapDispatchToProps = {
  // toggleIsDialerOpen,
  // setUser,
  // setMenu,
  // setIsLogin,
  // setToken
};

// export default connect(mapStateToProps, mapDispatchToProps)(APIManager);
// module.exports = APIManager;

export default APIManager;



// WEBPACK FOOTER //
// src/modules/theme/theme1/common/apiManager.js